// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__14OgD","content":"RecentSearches_content__1zTJl"};